// export const API_URL = 'http://localhost:3003';
export const token = () => localStorage.getItem('token');
export const API_URL = 'https://srv702611.hstgr.cloud:3003';
export const username = localStorage.getItem('UserAlias');